import { render, staticRenderFns } from "./ProcedureEdit.vue?vue&type=template&id=4ea19460&scoped=true&"
import script from "./ProcedureEdit.vue?vue&type=script&lang=js&"
export * from "./ProcedureEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureEdit.vue?vue&type=style&index=0&id=4ea19460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea19460",
  null
  
)

export default component.exports